import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common';

class MagstimTablePhysicians extends MagstimTable {


	initForSelect = (data, heightPx) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data), heightPx);
	}

	initForEdit = (data, heightPx) => {
		this.initTable(this.configTableData(data), heightPx);
	}

	configTableData(data) {
		return {
			columns: [
				{ title: CurrentLang().user_first_name, property: 'FirstName', isSearchable: true },
				{ title: CurrentLang().user_last_name, property: 'LastName', isSearchable: true},
				{ title: CurrentLang().physician_email, property: 'EmailAddress', isSearchable: true,  optional: true},
				{ title: CurrentLang().clinic_phone, property: 'Phone', isSearchable: true,  optional: true},
				{ title: CurrentLang().physician_type, property: 'PhysicianTypeStr'}
			],
			data: data
		};
    }
    
    resetFilters() {
		// console.log('MagstimTablePhysicians.resetFilters');
		super.resetFilters();
		this.addFilter('PhysicianTypeStr', CurrentLang().physician_type_referring);
	}
}

export default MagstimTablePhysicians;